import { render, staticRenderFns } from "./BeaconSelect.vue?vue&type=template&id=52db2ab0&"
import script from "./BeaconSelect.vue?vue&type=script&lang=js&"
export * from "./BeaconSelect.vue?vue&type=script&lang=js&"
import style0 from "./BeaconSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports